<div class="ds-dialog window-drag-handle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div class="ds-header-dialog">
    <h3>{{ 'VIDEO_CALL' | translate }}</h3>
    <div class="ds-flex">
      <mat-icon
        (click)="toggleMinimized()"
        svgIcon="window-select"
        class="ml-16 window-icon"
        *ngIf="!minimized"
      ></mat-icon>
      <mat-icon
        (click)="toggleMinimized()"
        svgIcon="window-open"
        class="ml-16 window-icon"
        *ngIf="minimized"
      ></mat-icon>
      <mat-icon (click)="close()" svgIcon="close-l" style="cursor: pointer" class="ml-16"></mat-icon>
    </div>
  </div>
  <div [ngClass]="{ 'window-hide': minimized, 'window-show': !minimized }">
    <div [id]="frameId"></div>
  </div>
  <div [ngClass]="{ 'window-hide': !minimized, 'window-show': minimized }">
    <div class="jitsi-toolbox-content-items">
      <div class="jitsi-toolbox-icon" (click)="executeCommand('toggleAudio')">
        <mat-icon [svgIcon]="isAudioMuted ? 'jitsi-mic-muted' : 'jitsi-mic'"></mat-icon>
      </div>
      <div class="jitsi-toolbox-icon" (click)="executeCommand('toggleVideo')">
        <mat-icon [svgIcon]="isVideoMuted ? 'jitsi-video-muted' : 'jitsi-video'"></mat-icon>
      </div>
      <div class="jitsi-toolbox-icon jitsi-hangup-menu-button" (click)="executeCommand('hangup')">
        <mat-icon [svgIcon]="'jitsi-hangup'"></mat-icon>
      </div>
    </div>
  </div>
</div>
